import { render, staticRenderFns } from "./ManagerSkills.vue?vue&type=template&id=87f0ab90&scoped=true&"
import script from "./ManagerSkills.vue?vue&type=script&lang=js&"
export * from "./ManagerSkills.vue?vue&type=script&lang=js&"
import style0 from "@/sass/08_modules/manager-skills.scss?vue&type=style&index=0&id=87f0ab90&scoped=true&lang=scss&"
import style1 from "@/sass/07_elements/multiselect.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87f0ab90",
  null
  
)

export default component.exports